import { defineMessages } from 'react-intl';

export default defineMessages({
    totalRepayment: {
        id: '_.draw_down.choose_amount.total_repayment',
        defaultMessage: 'Total repayment'
    }
});
